import React, { useContext, useEffect, useState } from 'react';
import { DndContext, DndProvider, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import { ItemType } from './draggable-wrapper-types.js';
import { DraggableWrapper } from './draggable-wrapper.js';
import { DRAGGABLE_IDENTIFIER, reorder } from './utils.js';
function transformData(data) {
    // Convert to <BaseDragItem> to inject our custom identifier.
    const copy = [...data];
    for (const item of copy) {
        item[DRAGGABLE_IDENTIFIER] = generateUUID();
    }
    return copy;
}
function InternalDraggableList(props) {
    const [, drop] = useDrop({
        accept: ItemType.Item,
    });
    const [innerData, setInnerData] = useState([]);
    useEffect(() => {
        setInnerData(transformData(props.data));
    }, [props.data]);
    const findItemIndex = (id) => {
        return innerData.findIndex(item => item[DRAGGABLE_IDENTIFIER] === id);
    };
    const moveItem = (id, atIndex) => {
        const itemIndex = findItemIndex(id);
        setInnerData((innerData) => reorder(innerData, itemIndex, atIndex));
    };
    const onReset = () => {
        setInnerData(transformData(props.data));
    };
    const onDragEnd = () => {
        // Convert back to <T> when finished.
        props.onDragEnd(innerData);
    };
    return (React.createElement("div", { ref: drop }, innerData.map((item, index) => (React.createElement(DraggableWrapper, { canDrag: props.canDrag, findItemIndex: findItemIndex, item: item, key: `c-draggable-wrapper-${index}`, moveItem: moveItem, onDragEnd: onDragEnd, onReset: onReset }, props.renderItem(item, index))))));
}
function DraggableList(props) {
    const context = useContext(DndContext);
    if (!context.dragDropManager) {
        return (React.createElement(DndProvider, { backend: HTML5Backend },
            React.createElement(InternalDraggableList, { ...props })));
    }
    return (React.createElement(InternalDraggableList, { ...props }));
}
export { DraggableList, };
//# sourceMappingURL=draggable-list.js.map